export const typesStoredcardall = {
    GET_STOREDCARDALL_SUCCESS:'GET_STOREDCARDALL_SUCCESS',
    GET_STOREDCARDALL_ERROR:'GET_STOREDCARDALL_ERROR',
    GET_STOREDCARDALL_BEGIN:'GET_STOREDCARDALL_BEGIN'
}
